import Swiper, { Navigation, Pagination } from 'swiper';
import selectors from '../globals/selectors';

export default () =>
	new Swiper(selectors.alsoChooseCarousel.swiper, {
		slidesPerView: 1,
		breakpoints: {
			1080: {
				slidesPerView: 4,
			},
			780: {
				slidesPerView: 3,
			},
		},
		spaceBetween: 13,
		modules: [Navigation, Pagination],
		navigation: {
			nextEl: selectors.alsoChooseCarousel.navNext,
			prevEl: selectors.alsoChooseCarousel.navPrev,
		},
		pagination: {
			el: selectors.alsoChooseCarousel.pagination,
		},
	});
